import { Controller as BaseController } from 'stimulus'
import Rails from '@rails/ujs'
import { useBusItem } from '@app/javascript/controllers/mixins/useBusItem.js'
import { flashError, flashNotice } from '@app/javascript/classes/flashMessages'

export class Controller extends BaseController {
  static targets = ['saveSearchButton', 'updateSearchButton', 'createAlertButton']

  static values = {
    currentSearchParams: Object,
    currentSavedSearchId: String
  }

  connect() {
    useBusItem(this, { addToBus: false })

    this.searchParams = this.currentSearchParamsValue
  }

  searchPageCriteriaChanged(event) {
    event.preventDefault()

    this.searchParams = event.detail.persistableSearchState

    this.toggleSaveSearchButton()
    this.toggleUpdateSearchButton()
    this.toggleCreateAlertButton()
  }

  toggleSaveSearchButton() {
    this.toggleEnabled(this.saveSearchButtonTarget, { isEnabled: this.hasSearchParams })
  }

  toggleUpdateSearchButton(state = true) {
    if (!this.hasUpdateSearchButtonTarget) return

    this.toggleEnabled(this.updateSearchButtonTarget, { isEnabled: state })
  }

  toggleCreateAlertButton() {
    if (!this.hasCreateAlertButtonTarget) return

    const searchText = this.searchParams?.search_text
    const hasSearchText = searchText !== undefined && searchText?.trim() !== ''

    this.toggleEnabled(this.createAlertButtonTarget, { isEnabled: hasSearchText })
  }

  redirectToNewAlert(event) {
    event.preventDefault()

    const params = { ...this.searchParams, alert: true }

    window.location.href = `/search/saved_searches/new?${$.param(params)}`
  }

  redirectToNewSearch(event) {
    event.preventDefault()

    const params = { ...this.searchParams }

    window.location.href = `/search/saved_searches/new?${$.param(params)}`
  }

  updateCurrentSearch(event) {
    event.preventDefault()

    const currentSearchState = this.searchParams
    const currentSearchId = this.currentSavedSearchIdValue

    if (!currentSearchState) return

    const data = { saved_search: { filters: currentSearchState } }

    Rails.ajax({
      type: 'PATCH',
      url: `/search/saved_searches/${currentSearchId}`,
      dataType: 'json',
      data: $.param(data),
      success: (response) => {
        flashNotice(response.message)

        this.toggleUpdateSearchButton(false)
        this.getBusItem('entities--flyout').reloadWhenTriggered()
      },
      error: (response) => {
        flashError(response.message)
      }
    })
  }

  toggleEnabled(elem, { isEnabled }) {
    if (!elem) return

    if (isEnabled) {
      elem.removeAttribute('disabled')
    } else {
      elem.setAttribute('disabled', 'disabled')
    }
  }

  get hasSearchParams() {
    return !!this.searchParams
  }
}
